<template>
  <div class="flex flex-col items-stretch">
    <div class="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 justify-between sm:items-center p-4 sm:p-5 bg-white border border-gray-100 rounded-t-lg shadow-sm">
      <h1 class="font-semibold text-base sm:text-lg text-gray-900"> Field Officers & Administrators - {{ total_rde }} </h1>
      <div class="flex space-x-4">
        <button class="rounded-lg px-4 py-2 border border-gray-200 text-sm font-medium text-expressgray flex items-center space-x-2 hover:bg-gray-50 transition-colors" @click="download_csv">
          <i class="fas fa-cloud-download-alt"></i>
          <span>Download</span>
        </button>
      </div>
    </div>
    <div class="flex w-full flex-col bg-white border-x border-b border-gray-100 rounded-b-lg shadow-sm mb-4">

      <div v-if="isLoading">
        <skeleton-table :rows="8" :columns="7" />
      </div>
      <div v-else>
        <rde-list-table :rowRaws="rdes"/>
      </div>
    </div>

    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 bg-white border border-gray-100 rounded-lg shadow-sm p-4" >
      <div class="flex items-center space-x-3 text-sm text-expressgray">
        <p>Records Per-Page</p>
        <select v-model="perPage" class="border border-gray-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:border-express">
          <option value="10">10</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="100">500</option>
          <option value="100">1000</option>
        </select>
      </div>

    <pagination :total-pages="totalPages"
                :total="total"
                :per-page="perPage"
                :current-page="currentPage"
                :has-more-pages="hasMorePages"
                @pagechanged="showMore">
    </pagination>
    </div>

  </div>




</template>

<script>

import RDEListTable from "@/components/uicomponents/tables/RDEListTable";
import SkeletonTable from "@/components/uicomponents/loader/SkeletonTable";
import {mapGetters} from "vuex";
export default {
  name: "rdetable",
  components:{
    "rde-list-table":RDEListTable,
    SkeletonTable
  },
  async created() {
    this.isLoading = true
    await this.$store.dispatch('admins/action_rde_list',{
      page: this.currentPage,
      perPage: this.perPage,
      toast:this.$toast,
      router:this.$router
    });
    this.filter_retailers()
  },
  data(){
    return {
      total_rde:null,
      isLoading: false,
      totalPages:10,
      total:100,
      perPage: 10,
      currentPage:1,
      hasMorePages: true,
      rdes:[]
    }
  },
  computed: {
    ...mapGetters({
      rde_list: 'admins/rde_list',

    }),
  },
  methods:{
    showMore(data){
      console.log(data)
    },
    download_csv(){
      var csv = '';
      this.rdes.forEach(function(row) {
        csv += row.join(',');
        csv += "\n";
      });

      // console.log(csv);
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'rdes.csv';
      hiddenElement.click();
    },
    filter_retailers(){
      let myresult = []
      this.total_rde = this.rde_list.total

    //  console.log("this.total_rde.next_page_url",this.total_rde.next_page_url)

      if(this.total_rde===undefined || this.total_rde.next_page_url === undefined){
        this.hasMorePages = false
      }
      else this.hasMorePages = this.total_rde.next_page_url !== null;

      let total_rde_count =1
      let total_rde_per_page =1
      if ( typeof(this.total_rde)  !== 'undefined' && typeof(this.total_rde.count) !== 'undefined') {
         total_rde_count = this.total_rde.count
      }else{
        total_rde_count = 0
      }

      if ( typeof(this.total_rde)  !== 'undefined' && typeof(this.total_rde.per_page) !== 'undefined') {
        total_rde_per_page = this.total_rde.per_page
      }else{
        total_rde_per_page = 0
      }

     // let total_rde_count = this.total_rde.count === undefined ?  0 : this.total_rde.count

      // if(this.total_rde  === null || this.total_rde.count === null ){
      //   this.totalPages = 0
      // }else{
        this.totalPages = total_rde_count/total_rde_per_page
      // }


      this.rde_list.data?.forEach((item, index)=>{
        // console.log('rdeList',item)
        myresult.push( [
          item['name']  ,
          item['email']  ,
          item['phone']  ,
          item['country'],
          item['type'],
          item['status'],
          item['id']
        ])
      })
      this.rdes = myresult

      this.isLoading = false
      this.$forceUpdate()

    },
  }
}
</script>

<style scoped>

</style>
